// extracted by mini-css-extract-plugin
export var bubble = "_redotech-redo-web-lib-user-image-bubble";
export var container = "_redotech-redo-web-lib-user-image-container";
export var contrastBorder = "_redotech-redo-web-lib-user-image-contrast-border";
export var greyOut = "_redotech-redo-web-lib-user-image-grey-out";
export var initialsColor0 = "_redotech-redo-web-lib-user-image-initials-color-0";
export var initialsColor1 = "_redotech-redo-web-lib-user-image-initials-color-1";
export var initialsColor10 = "_redotech-redo-web-lib-user-image-initials-color-10";
export var initialsColor11 = "_redotech-redo-web-lib-user-image-initials-color-11";
export var initialsColor2 = "_redotech-redo-web-lib-user-image-initials-color-2";
export var initialsColor3 = "_redotech-redo-web-lib-user-image-initials-color-3";
export var initialsColor4 = "_redotech-redo-web-lib-user-image-initials-color-4";
export var initialsColor5 = "_redotech-redo-web-lib-user-image-initials-color-5";
export var initialsColor6 = "_redotech-redo-web-lib-user-image-initials-color-6";
export var initialsColor7 = "_redotech-redo-web-lib-user-image-initials-color-7";
export var initialsColor8 = "_redotech-redo-web-lib-user-image-initials-color-8";
export var initialsColor9 = "_redotech-redo-web-lib-user-image-initials-color-9";
export var initialsWrapper = "_redotech-redo-web-lib-user-image-initials-wrapper";
export var large = "_redotech-redo-web-lib-user-image-large";
export var medium = "_redotech-redo-web-lib-user-image-medium";
export var mediumSmall = "_redotech-redo-web-lib-user-image-medium-small";
export var mediumSmallMedium = "_redotech-redo-web-lib-user-image-medium-small-medium";
export var micro = "_redotech-redo-web-lib-user-image-micro";
export var small = "_redotech-redo-web-lib-user-image-small";
export var tiny = "_redotech-redo-web-lib-user-image-tiny";
export var xTiny = "_redotech-redo-web-lib-user-image-x-tiny";